// import { api } from './NetworkUtility';

export const logError = (error, callbackHandler) => {
    console.log("error boudary caught error");
    console.log(error);
    // const url = `/logerror`; //TODO: replace endpoint and post payload with correct url and data object - story 131042
    
    // api.post(url, error)
    //     .then(response => {
    //         callbackHandler(true, response);
    //     })
    //     .catch((error) => {
    //         callbackHandler(false, error);
    //     });

    //still invoke callbackHandler so stubbed out calls to logError work properly
    callbackHandler(true, "success");
}